import React, { useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppSiteHeaderSelector } from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector } from "src/_common/hooks/selectors/userSelector";
import { INSIDERODEO_EVENT_STORAGE, SELECTED_EVENT_STORAGE, STORAGE, URLS } from "src/_config";

const SideMenus = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const { eventId, performanceId } = useParams<any>();
  const siteHeader = useAppSiteHeaderSelector();
  const isInsideRodeoTokenExists = localStorage.getItem(INSIDERODEO_EVENT_STORAGE);
  const userDetails = useAppUserDetailsSelector();
  const userApi = useUserApi();
  const userAction = useAppUserAction();
  const history = useHistory();

  const logOut = (e: React.MouseEvent) => {
    userApi.callLogout(
      (message: string, resp: any) => {
        userAction.logout();
        localStorage.removeItem(STORAGE);
        localStorage.removeItem(SELECTED_EVENT_STORAGE);
        localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);
        history.push(URLS.HOME);
      },
      (message: string) => {
        userAction.logout();
      }
    );
  };

  return (
    <>
      {showMenu ? <div className="offcanvas-backdrop fade show" /> : null}

      <div
        className={
          "offcanvas offcanvas-end offcanvas-menu " +
          (eventId && siteHeader == 1 ? "" : "d-none ") +
          (showMenu ? "show" : "hiding")
        }
      >
        <div className="offcanvas-header">
          <button type="button" className="btn-close" onClick={() => setShowMenu(!showMenu)} />
        </div>
        <div className="offcanvas-body">
          <div className="offcanvas-logo">
            <img src="/images/logo.svg" alt="" />
          </div>
          <div className="offcanvas-menu-list">
            <ul>
              <li>
                {!isInsideRodeoTokenExists ? (
                  <Link to={URLS.HOME}>
                    <img src="/images/rodeo-events.svg" alt="" />
                    Rodeo Events
                  </Link>
                ) : null}
              </li>
              <li>
                <Link to={URLS.EVENT.PAST_RODEO_LIST}>
                  <img src="/images/past-rodeo-events.svg" alt="" />
                  Past Rodeo Events
                </Link>
              </li>
              {userDetails && performanceId ? (
                <li>
                  <Link to={"/challenge/" + eventId + "/" + performanceId}>
                    <img src="/images/challenge.svg" alt="" />
                    Challenge
                  </Link>
                </li>
              ) : null}

              <li>
                {userDetails ? (
                  <Link to={URLS.USER.PROFILE}>
                    <img src="/images/profile.svg" />
                    My Profile
                  </Link>
                ) : (
                  <Link to={URLS.LOGIN} onClick={() => localStorage.setItem("currentPage", window.location.pathname)}>
                    <img src="/images/login.svg" />
                    Login
                  </Link>
                )}
              </li>

              {/* <li>
                {userDetails && eventId ? (
                  <Link to={`/winning-ticket/${eventId}`}>
                    <img src="/images/correct-picks.svg" alt="" />
                    My Correct Picks
                  </Link>
                ) : null}
              </li>

              <li>
                {userDetails && eventId ? (
                  <Link to={`/my-team/${eventId}`}>
                    <img src="/images/my-team.svg" alt="" />
                    My Team
                  </Link>
                ) : null}
              </li> */}

              <li>
                <Link to={"/cms/about-us"}>
                  <img src="/images/about.svg" alt="" />
                  About Us
                </Link>
              </li>

              <li>
                <Link to={"/cms/legal"}>
                  <img src="/images/legal.svg" alt="" />
                  Legal
                </Link>
              </li>

              <li>
                <Link to={"/cms/contact-us"}>
                  <img src="/images/contact.svg" alt="" />
                  Contact Us
                </Link>
              </li>

              <li>
                <Link to={"/cms/prize-winner"}>
                  <img src="/images/prize.svg" alt="" />
                  Prize
                </Link>
              </li>

              <li>
                {userDetails && (
                  <a style={{ color: "var(--color-grey)" }} onClick={(e) => logOut(e)}>
                    <img src="/images/login.svg" alt="" />
                    Logout
                  </a>
                )}
              </li>
            </ul>
          </div>
          <div className="powered-by">
            <p>Powered by</p>
            <img src="/images/teton-ridge.svg" alt="" />
          </div>
        </div>
      </div>
      <div
        className={"bottom-menu-btn " + (eventId && siteHeader == 1 ? "" : "d-none")}
        onClick={() => setShowMenu(!showMenu)}
        style={{ paddingRight: showMenu ? "0px" : "15px" }}
      >
        <a>
          <img src="/images/bottom-menu.png" />
        </a>
      </div>
    </>
  );
};

export default SideMenus;
